import { Component } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { SystemService } from '../crud-service';
import { SystemCrudIndex } from './crud-index';

@Component({
  selector: 'app-system-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemService],
})
export class SystemIndexComponent extends SystemCrudIndex {
  ngOnInit(): void { }

  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Nome',
      name: 'name',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SELECT,
      label: 'TIPO',
      name: 'type',
      options: Object.values(SystemTypeEnum),
      placeholder: 'Selecione uma opção',
      validation: [Validators.required],
    }
  ];

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            return this.mapBackendDataToDisplay(item);
          })
        );
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    // Filtro pelo nome
    if (filter.name) params.name = filter.name.trim().toUpperCase();

    if (filter.type) {
      params.type = this.mapTypeToBackendValue(filter.type);
    }

    return params;
  }

  private mapTypeToBackendValue(type: SystemTypeEnum): string | undefined {
    switch (type) {
      case SystemTypeEnum.APPLICATION:
        return SystemTypeIdEnum[SystemTypeEnum.APPLICATION] as unknown as string;
      case SystemTypeEnum.SYSTEM:
        return SystemTypeIdEnum[SystemTypeEnum.SYSTEM] as unknown as string;
      default:
        return undefined;
    }
  }

  private mapBackendDataToDisplay(item: any): any {
    if (item.type) {
      if (item.type === SystemTypeIdEnum[SystemTypeEnum.APPLICATION]) {
        item.type = SystemTypeEnum.APPLICATION;
      } else if (item.type === SystemTypeIdEnum[SystemTypeEnum.SYSTEM]) {
        item.type = SystemTypeEnum.SYSTEM;
      }
    }

    if (item.createdAt) {
      item.createdAt = this.formatDate(item.createdAt);
    }

    return item;
  }

  private formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
